// Define api end points here

export const AUTH = "/auth";
export const SIGNUP = "/register";
export const LOGIN = "/login";
export const CATEGORIES = "/categories";
export const CUSTOMER = "/customer";
export const WISHLIST = "/wish-list";

export const COLORS = "/colors";

export const PRODUCTS = "/products";
export const HOTDEALS = "/hot-deals";

export const RELATED_PRODUCTS = "/related-products";
export const TRADING = "/trading";

export const REVIEWS = "/reviews";

export const REPLIES = "/replies";

export const LATEST = "/latest";

export const ORDER = "/order";
export const LIST = "/list";
export const CONTACTUS = "/contactUs";

export const NEWSLETTER = "/newsletter";
export const ADD = "/add";
export const FAQ = "/faq";

export const PLACE = "/place";
export const TRACK = "/track";

export const REMOVE_ALL = "/remove_all";
export const CUSTOMER_ID = "?customer_id";

export const UPDATE_PROFILE = "/update-profile";

export const SOCIAL_MEDIA = "/social-media";
export const LINKS = "/links";

export const COMPANY_INFORMATION = "/company-information";

export const COUPON = "/coupon";
export const APPLY = "/apply";
export const CODE = "?code";

export const REMOVE = "/remove";
export const PRODUCT_ID = "?product_id";

export const SEARCH = "/search";
export const SEARCH_QUERY = "search";
export const ORDER_BY = "order";
export const NAME = "?name";
export const SUBMIT = "/submit";
export const BRANDS = "/brands";
export const ATTRIBUTES = "/attributes";
export const PRICE = "/price";
export const START = "?start";
export const END = "end";
export const STORE = "/store";

export const BANNERS = "/banners";
export const BANNER_TYPE = "?banner_type";

export const STATUS = "?status";
export const ADS = "/ads";

export const BLOGS = "/blogs";
export const BLOGDETAIL = "/blog";
export const COUNTRY = "/country";
export const FORGOT_PASSWORD = "/forgot-password";

export const RESET_PASSWORD = "/reset-password";
export const CHANGE_PASSWORD = "/change_password";

export const TOP_PRODUCTS = "/top-products";
export const PAGE = "?page";

export const TRADE_PRODUCTS = "/trade-products";


export const DETAILS = "/details";
export const SHOW = "/show";

export const GET_PAGE = "/get_pages";
export const TYPE = "?type";

// Chat Endpoints
export const CHATS = "/chats"
export const SEEN = "/seen"



// Below is the list of all Seller input apis
export const SELLER = "/seller";

// seller profile
export const SELLER_PROFILE = "/profile";
export const SELLER_PROFILE_UPDATE = "/profile/update";
export const SELLER_CHANGE_PASSWORD = "/profile/change-password";

// seller product
export const SELLER_PRODUCT_STORE = "/products/store";
export const SELLER_PRODUCT_STORE_BULK = "/products/upload-excel-products";
export const SELLER_PRODUCT_UPDATE = "/products/update";
export const SELLER_PRODUCT_DELETE = "/products/delete";
export const SELLER_PRODUCT_DELETE_BULK = "/products/delete-in-bulk";


// seller notifications
export const SELLER_NOTIFICATIONS = "/seller/notifications";
export const SELLER_NOTIFICATIONS_Marked_Clicked = "/seller/notifications/mark";
export const SELLER_NOTIFICATIONS_Marked_Read = "/seller/notifications/mark-read";

// seller orders
export const SELLER_ORDERS = "/seller/orders";
export const SELLER_ORDER_SHOW = "/seller/orders/show";




// end

// == End ==
